document.addEventListener("DOMContentLoaded", () => {
  const swiper = new Swiper(".custom-video-testimonial-swiper", {
    slidesPerView: 2,
    spaceBetween: 10,
    centeredSlides: true,
    initialSlide: 1,
    breakpoints: {
      768: {
        spaceBetween: 20,
        centeredSlides: false,
        initialSlide: 1,
        slidesPerView: 3,
      },
    },
  });
});
